wbApp.directive('wbRecurrenceEditor',
    function () {
        return {
            restrict: 'A',
            require: '^ngModel',
            priority: 1,
            scope: {
                recurrence: '=ngModel',
                startDate: '='
            },
            replace: true,
            templateUrl: 'recurrence-editor-template.html',
            controller: ['$scope', function ($scope) {

                var defaultRecurrence = {
                    type: 2,
                    repeatByWeeks: 1,
                    endByType: 1,
                    range: 2,
                    rangeDays: 1,
                    endByOccurenceCount: 10,
                    repeatEveryWeekday: [false, false, false, false, false, false, false]
                }

                if (!$scope.recurrence) {
                    $scope.recurrence = angular.extend({}, defaultRecurrence);
                } else {
                    $scope.recurrence = angular.extend({}, defaultRecurrence, $scope.recurrence);
                }

                $scope.$watch('startDate', function (newValue) {
                    if (!!newValue) {
                        var weekDayIdx = moment(newValue).isoWeekday() - 1;

                        for (var i = 0; i < 7; i++) {
                            $scope.recurrence.repeatEveryWeekday[i] = i === weekDayIdx;
                        }
                    }
                });
            }]
        }
    });